import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2";

// Connects to data-controller="confirm"
export default class extends Controller {
  static targets = ['confirm', 'closeConfirm', 'refreshForm', 'endSession']
  static showing = false
  static interval
  static sweetAlertHandle
  static values = {
    msg: String,
    actionUrl: String,
    nextUrl: String,
    rootUrl: String,
    timer: Number,
    rewards: Number,
    perDay: Number,
    achieved: String,
    resetSession: String
  }

  connect() {
    // Turbo.setConfirmMethod(this.confirmMethod)
    Turbo.config.forms.confirm = this.#confirmMethod
  }

  confirmTargetConnected(ele) {
    let self = this

    setTimeout(() => {
      self.confirmQuestion(ele);
    }, 5000)

    self.setIntervalForConfirm(ele)    
  }

  setIntervalForConfirm(ele) {
    let self = this;
    self.interval = setInterval(() => {
      if (!self.showing) {
        self.confirmQuestion(ele);
      }
    }, 60000)
  }

  confirmQuestion(ele) {
    let self = this
    self.showing = true
    self.sweetAlertHandle = Swal.fire({
      showConfirmButton: false,
      position: "top-start",
      showClass: self.showClass(),
      hideClass: self.hideClass(),
      customClass: self.customClass(),
      html: self.getTemplate(),
      backdrop: false,
      allowEscapeKey: false,
    })
  }

  async startWorking(callback, value) {
    let data = { password: value } 
    try {
      const response = await fetch(callback, {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data, value);
      });
   } catch (error) {
     console.log(error)
    }    
  }

  getTemplate() {
    return document.getElementById("swal-template").innerHTML
  }

  showClass() {
    return {
      popup: `
        animate__animated
        animate__fadeInDown
        animate__faster
            `,
    }
  }

  hideClass() {
    return {
      popup: `
        animate__animated
        animate__fadeOutUp
        animate__faster
      `,
    }
  }

  customClass(extra_class) {
    return {
      container: `swal2-top-center swal2-action-top-0 ${extra_class}`,
    }
  }

  closeConfirmTargetConnected(ele) {
    if (this.sweetAlertHandle) {      
      this.sweetAlertHandle.close()
    }
  }

  refreshFormTargetConnected(ele) {
    if (this.interval) {      
      clearInterval(this.interval)
      this.confirmQuestion(ele)
    }
    this.setIntervalForConfirm(ele);
  } 
  
  endSessionTargetConnected(element) {
    let self = this
    Swal.fire({
      title: this.msgValue,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, do it!",
      backdrop: false,
      allowEscapeKey: false,
      position: "top-start",
      showClass: self.showClass(),
      hideClass: self.hideClass(),
      customClass: self.customClass('swal-height-120'),
    }).then((result) => {
      console.log(self)
      console.log(self.rootUrlValue, self.actionUrlValue);
      if (result.isConfirmed && self.actionUrlValue != "") {
        self.resetSession();
      }
    })
  }

  async resetSession() {
   try {
    const response = await fetch(this.actionUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
    })
      .then((res) => res.json())
      .then(data => {
        console.log(data)
        // window.location.replace(data.callback_url);
      })
   } catch (error) {
     console.log(error)
    }    
  }  

  #confirmMethod(message, element) {
    Swal.fire({
      title: message,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, do it!",
      theme: "bootstrap-4"
    }).then((result) => {
      if (result.isConfirmed) {
        element.submit()
        // console.log(element)
        // Turbo.navigator.submitForm(element)
      }
    })
  }
}
